<svg fill='none' height='15' viewBox='0 0 15 15' width='15' xmlns='http://www.w3.org/2000/svg'></svg>;

import { IconProps } from '@/components/Icon';

export const IconReset = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 15 15' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.73144 5.18185H12.5L10.7358 3.41656C10.1678 2.84857 9.46035 2.44012 8.68447 2.23226C7.90858 2.02441 7.09165 2.02447 6.3158 2.23244C5.53995 2.44041 4.83252 2.84897 4.26463 3.41704C3.69674 3.9851 3.2884 4.69266 3.08067 5.46858M2.50055 10.892V8.12345M2.50055 8.12345H5.26912M2.50055 8.12345L4.26418 9.88874C4.83216 10.4567 5.53965 10.8652 6.31553 11.073C7.09142 11.2809 7.90835 11.2808 8.6842 11.0729C9.46005 10.8649 10.1675 10.4563 10.7354 9.88826C11.3033 9.32019 11.7116 8.61264 11.9193 7.83672M12.5 2.41328V5.18074'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.42612'
      />
    </svg>
  );
};
